// Convierte un nombre de producto en un slug legible para la URL, ej:
//   "Toalla en rollo Fapsa 6 rollos de 180m" -> "toalla-en-rollo-fapsa-6-rollos-de-180m"
export const slugify = (texto) =>
  String(texto || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // quita acentos
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// La ruta de un producto siempre termina en "-<artId>" (ej. /producto/toalla-en-rollo-fapsa-1),
// así que el nombre puede cambiar sin romper links ya compartidos: solo importa
// el número al final. Esto también evita choques entre productos con nombres iguales.
export const productoPath = (producto) => `/producto/${slugify(producto.artNom)}-${producto.artId}`;

// Extrae el artId desde el parámetro de ruta ":slug", que puede venir como
// "toalla-en-rollo-fapsa-1", o directamente como "1" (compatibilidad con
// links viejos /producto/:id sin slug).
export const idDesdeSlug = (slugParam) => {
  const texto = String(slugParam || '').trim();
  if (/^\d+$/.test(texto)) return texto;

  const match = texto.match(/-(\d+)$/);
  return match ? match[1] : texto;
};
